module.exports = __webpack_public_path__ + "media/images/icon-starter-86e390042f58c1cc3a6c6f4def690334.svg";